import React, { useState, memo, useEffect, useMemo } from 'react';
import { Icon, Text, useTheme } from '@Sage/hoi-poi-ui';
import Context from 'managers/Context';
import { getLiteral } from 'utils/getLiteral';
import PopoverMenu from 'components/PopoverMenu';

const TimezoneSelector = memo(({ onChange, timeZone }) => {
    const theme = useTheme();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        Context.serverListManager
            .getList('fm_iana_time_zone')
            .then((result) => {
                setOptions(
                    result.map((option) => ({
                        ...option,
                        value: option.idianazone,
                        label: option.descripcion,
                        id: option['-id'], // Preserve the ID field for lookup
                    })),
                );
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const currentTimezone = useMemo(() => {
        if (!options?.length) return undefined;

        let selected;

        if (timeZone) {
            // Handle both timezone ID (number) and timezone string
            if (typeof timeZone === 'number' || !isNaN(parseInt(timeZone, 10))) {
                const timeZoneId = parseInt(timeZone, 10);
                selected = options.find((option) => parseInt(option.id, 10) === timeZoneId);
            } else {
                selected = options.find((option) => option.value === timeZone);
            }
        } else {
            const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            selected = options.reduce((obj, current) => {
                if (current.ianazonenames?.includes(browserTimezone)) obj = current;
                return obj;
            }, {});
        }
        return selected;
    }, [options, timeZone]);

    return (
        <PopoverMenu
            title={getLiteral('label_timezone')}
            advice={getLiteral('label_automations_date_time_zone_desc')}
            options={options}
            onChange={onChange}
            value={currentTimezone}
        >
            <div className="fm-automation__timezone-selector">
                <Icon
                    name="timeZone"
                    isTruncated
                    useTooltip
                    color={theme.colors.actionMinor[500]}
                />
                <Text>{currentTimezone?.label}</Text>
            </div>
        </PopoverMenu>
    );
});

TimezoneSelector.displayName = 'LangTimezoneSelectoruageSelector';

export default TimezoneSelector;
